import { ngApmApp } from '../../../app/apm/ApmApp';

angular.module('splunk.apm', []).component('apmApp', ngApmApp);
